import { NAVIGATE_ROUTE } from '@app/modules/routes/common-route';

export const CURRENT_URL_KEY = 'CURRENT_URL';

const EXCLUDED_PATHS: string[] = [NAVIGATE_ROUTE.SC001, NAVIGATE_ROUTE.SC014];

const isExcludedPath = (path: string) => EXCLUDED_PATHS.some((excluded) => path.startsWith(excluded));

export const saveCurrentUrl = (): void => {
  const path = window.location.pathname + window.location.search;
  if (!isExcludedPath(path)) {
    localStorage.setItem(CURRENT_URL_KEY, path);
  }
};

export const getCurrentUrl = (): string | null => {
  return localStorage.getItem(CURRENT_URL_KEY);
};
